import { mutatorAction } from 'satcheljs';
import { getStore } from '../store/Store';

/**
 * Sets showFolderPane value in store to passed in value
 * @param showFolderPane Whether to show folder pane
 */
export default mutatorAction('setShowFolderPane', (showFolderPane: boolean) => {
    getStore().showFolderPane = showFolderPane;
});
